const STORAGE_PREFIX = "ask-puntt.review-preflight:";

export type ReviewPreflightPersistedState = {
  selectedIds: string[];
  submitted: boolean;
};

export function reviewPreflightStorageKey(messageId: string): string {
  return `${STORAGE_PREFIX}${messageId}`;
}

export function readReviewPreflightState(
  messageId: string,
): ReviewPreflightPersistedState | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(
      reviewPreflightStorageKey(messageId),
    );
    if (!raw) return null;
    const parsed = JSON.parse(raw) as unknown;
    if (parsed == null || typeof parsed !== "object") return null;
    const row = parsed as Record<string, unknown>;
    const selectedIds = row.selectedIds;
    const submitted = row.submitted;
    if (!Array.isArray(selectedIds)) return null;
    if (typeof submitted !== "boolean") return null;
    return {
      selectedIds: selectedIds.filter(
        (id): id is string => typeof id === "string",
      ),
      submitted,
    };
  } catch {
    return null;
  }
}

export function writeReviewPreflightState(
  messageId: string,
  state: ReviewPreflightPersistedState,
): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(
    reviewPreflightStorageKey(messageId),
    JSON.stringify(state),
  );
}
